import { SipSetting, SipSettingErrors } from './sipSetting.types';

export function adaptToCreate(
  sipSetting: SipSetting,
): SipSetting {
  return sipSetting;
}

export function adaptErrorResponsesMessages(
  response: any,
  bodyData: any
): SipSettingErrors {

  const { errorResponses } = response.action.payload.data;

  const errors: { [key: string]: { error: string, data: any}[] } = {};

  Object.keys(errorResponses).map((keyResponse) => {
    const keyIndex = keyResponse
      .match(/\[[0-9]\]/)?.[0]
      .replace(/(\[)|(\])/gi, '') as any;

    const key = keyResponse.split(/\[[0-9]\]/)[0];

    const keyData = bodyData[key];
    const data = Array.isArray(keyData) ? keyData[keyIndex as number] : keyData;
    const error = errorResponses?.[keyResponse]?.body?.error?.message;

    if (Array.isArray(errors[key])) {
      (errors[key]).push({
        error,
        data,
      });
    } else {
      errors[key] = [{
        error,
        data
      }];
    }
  });

  const {
    networkElements,
    sipInfo,
    sipTimer,
    prefixes,
  } = errors;

  const hasError = !!networkElements || !!sipInfo || !!sipTimer || !!prefixes;

  return {
    hasError,
    networkElements,
    sipInfo,
    sipTimer,
    prefixes,
  };
}
